module.exports = __webpack_public_path__ + "li.64c4108b.svg";